import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getBet = (params) => {
    return axios.get(`${backendHost}/api/admin/bet/list`, {params});
};

export {
    getBet
}